import { render, staticRenderFns } from "./Pfandrückgabe.vue?vue&type=template&id=a6502a54&scoped=true&"
import script from "./Pfandrückgabe.vue?vue&type=script&lang=js&"
export * from "./Pfandrückgabe.vue?vue&type=script&lang=js&"
import style0 from "./Pfandrückgabe.vue?vue&type=style&index=0&id=a6502a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6502a54",
  null
  
)

export default component.exports